import { normalizeCategoryLookupKey } from '@/utils/market-category-label.js';

/** 首页 Feed「加密分钟盘」筛选 tab（前端本地分类，非 API 强制展示文案） */
export const FEED_CRYPTO_MINUTE_CATEGORY_KEY = 'crypto_minute_updown';

const SPORT_CATEGORY_KEYS = new Set(['sport', 'sports']);

export function isSportFeedCategoryKey(raw) {
  return SPORT_CATEGORY_KEYS.has(normalizeCategoryLookupKey(raw));
}

/** API「Crypto」分类 tab（与本地加密分钟盘 tab 不同） */
export function isCryptoFeedCategoryKey(raw) {
  return normalizeCategoryLookupKey(raw) === 'crypto';
}

/** @param {{ category?: string }} row collection/page 原始行 */
export function isSportFeedRow(row) {
  return isSportFeedCategoryKey(row?.category);
}

/**
 * 首页卡片展示用 categoryKey：沿用 API 原始分类（不再把非体育统一改写成加密分钟盘）
 * @param {string} rawCategoryKey API category
 */
export function resolveFeedListDisplayCategoryKey(rawCategoryKey) {
  return normalizeCategoryLookupKey(rawCategoryKey);
}
